// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './GachaEffectModal.css';

// React Modalで実装
import Modal from 'react-modal';
import GachaEffectUploadModal from './GachaEffectUpload';
import { useTranslation } from "react-i18next";

const GachaEffect = ({ modalIsOpen, closeModal, shopInfo, setShopInfo, getShop }) => {
  const { t } = useTranslation();
    
  const originals = shopInfo.originalEffectPattern;

  const videoSrc = (rank) => {
    if (shopInfo.effectType <= 1000) {
      return `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-${rank}.mp4`;
    } else {
      if (originals) {
        const original = originals.find(o => o.id === Number(shopInfo.effectType));
        if (original) {
          const item = original.items.find(i => i.rank === rank);
          if (item) {
            return `${process.env.REACT_APP_ASSET_URL}${item.path_with_version}`;
          }
        }
      }
    }
  }

    // const videoSrc = (rank) =>
    //   `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-${rank}.mp4`

  const cookies = document.cookie.split('; ');
  const headers = {
    'X-XSRF-TOKEN': decodeURIComponent(cookies.find(c => c.startsWith(process.env.REACT_APP_XSRF_TOKEN))?.split('=')[1]),
    'Bearer': decodeURIComponent(cookies.find(c => c.startsWith('token'))?.split('=')[1]),
  };

  const [GachaEffectUploadModalIsOpen, setGachaEffectUploadModalIsOpen] = useState(false);
  
  const openGachaEffectUploadModal = () => {
    setGachaEffectUploadModalIsOpen(true);
  }

  const closeGachaEffectUploadModal = () => {
    setGachaEffectUploadModalIsOpen(false);
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="gacha-effect-modal"
        overlayClassName="gacha-effect-modal-overlay"
        contentLabel="Example Modal"
      >
        <div className="gacha-effect-modal-title" id="top">{t('gacha_effect.title')}</div>
        <div className="clearfix"></div>
        <div className="gacha-effect-modal-form">
          <div className="gacha-effect-modal-select">
            <select name="gachaEffect" id="gachaEffect" value={shopInfo.effectType} onChange={(e) => setShopInfo({ ...shopInfo, effectType: e.target.value })}>
              <option value="1">{t('gacha_effect.fireworks')}</option>
              <option value="2">{t('gacha_effect.circle')}</option>
              <option value="3">{t('gacha_effect.warp')}</option>
              <option value="4">{t('gacha_effect.happy')}</option>
              <option value="5">{t('gacha_effect.fall')}</option>
              <option value="6">{t('gacha_effect.bolt')}</option>
              <option value="7">{t('gacha_effect.whirlpool1')}</option>
              <option value="8">{t('gacha_effect.whirlpool2')}</option>
              {originals && originals.map((o, i) => <option key={i} value={o.id}>{o.name}</option>)}
            </select>
            <br />
            <button className="gacha-effect-modal-form-upload-button" onClick={openGachaEffectUploadModal}>{t('gacha_effect.upload')}</button>
          </div>
          {/* <div className="gacha-effect-modal-form-title"><a href="#upload">動画をアップロード</a></div> */}
          <div className="gacha-effect-modal-imgs">
            <div className="gacha-effect-modal-img">
              <video src={videoSrc(1)} autoPlay muted loop playsInline></video>
              {t('gacha_effect.rank1')}
            </div>
            <div className="gacha-effect-modal-img">
              <video src={videoSrc(2)} autoPlay muted loop playsInline></video>
              {t('gacha_effect.rank2')}
            </div>
            <div className="gacha-effect-modal-img">
              <video src={videoSrc(3)} autoPlay muted loop playsInline></video>
              {t('gacha_effect.rank3')}
            </div>
            <div className="gacha-effect-modal-img">
              <video src={videoSrc(4)} autoPlay muted loop playsInline></video>
              {t('gacha_effect.rank4')}
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
        <div className="gacha-effect-modal-button">
          <button className="gacha-effect-modal-button-cancel" onClick={closeModal}>{t('gacha_effect.decision')}</button>
        </div>
      </Modal>
      <GachaEffectUploadModal
        modalIsOpen={GachaEffectUploadModalIsOpen}
        closeModal={closeGachaEffectUploadModal}
        shopInfo={shopInfo}
        setShopInfo={setShopInfo}
        getShop={getShop}
      />
    </>
  );
}

export default GachaEffect;